import { Link } from "react-router";
import Incidents from "~/components/Incidents";
import IntroductionVideo from "~/components/IntroductionVideo";
import References from "~/components/References";

export default function Hero() {
  return (
    <section className="overflow-hidden overflow-lg-visible pt-16 pt-lg-64">
      <div className="container">
        <div className="align-items-center flex-column-reverse flex-lg-row gx-32 gy-16 row">
          <Incidents className="col-12 col-lg-5 mw-32rem" />

          <div className="col-12 col-lg-7 text-center text-lg-start">
            <h1 className="display-5 fw-semi-bold">
              Notice
              {" "}
              <span className="fw-bold text-primary">downtime</span>
              <br />
              before your customers
            </h1>

            <h4 className="fw-medium lh-base mt-12">
              Website, API, and port monitoring, cron job monitoring, and eye-candy hosted status pages. Start
              {" "}
              <span className="fw-bold">50 free monitors</span>
              {" "}
              with
              {" "}
              <span className="fw-bold">5-minute checks</span>
              .
            </h4>

            <div className="d-flex flex-column">
              <div className="d-flex flex-column flex-lg-row gap-8 mt-16 align-items-lg-start">
                <div className="d-flex flex-column gap-2">
                  <Link className="btn btn-lg btn-primary" to="/sign-up">Try WebGazer now</Link>

                  <p className="d-lg-none fs-8 m-0 text-muted">14-day free trial, no credit card required</p>
                </div>

                <IntroductionVideo />
              </div>

              <p className="d-none d-lg-block fs-8 mt-2 text-muted">14-day free trial, no credit card required</p>
            </div>
          </div>
        </div>
      </div>

      <References className="mt-40" />
    </section>
  );
}
